var exports = {
  "kL": "x43aef4ae--7cbb48--container",
  "pq": "x43aef4ae--7cbb48--info",
  "nf": "x43aef4ae--7cbb48--link",
};

module.exports = exports;
